var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('transition',{attrs:{"name":"slide"}},[(_vm.loading)?_c('Loading'):_vm._e(),(_vm.error && !_vm.loading)?_c('ErrorBooklets'):_vm._e(),(!_vm.loading && !_vm.error)?_c('router-view'):_vm._e()],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }